@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div cdkDrag class="popup_main_div add_edit_allowance" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>{{ dialogTitle }}</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form
        fxLayout="column"
        fxFlex="1 0 auto"
        name="liabilityForm"
        #liabilityForm="ngForm"
        (ngSubmit)="OnSubmit(liabilityForm)"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTACTGUID),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONTACTGUID),
            }"
            class="example"
            appearance="outline"
            fxFlex="50"
            class="pr-1"
          >
            <mat-label>Contact Name</mat-label>

            <mat-chip-grid #chipListContact aria-label="Matter selection">
              @for (Contactdata of Contactname; track Contactdata) {
                <mat-chip-row (removed)="removeContact(Contactdata)" class="mat-chips-selected">
                  {{ Contactdata | slice: 0 : 40 }}
                  @if (Contactdata.length > 30) {
                    ...
                  }
                  <button matChipRemove class="canclebutton">
                    <mat-icon style="font-size: 18px !important">cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              <input
                matInput
                (keydown.Tab)="Contactdatashow($event)"
                matTooltip="{{ toolTipList ? toolTipList?.CONTACTNAME?.HOVER : '' }}"
                [(ngModel)]="EstateLiabilityForm.CONTACTNAME"
                #MatterInput2
                [matAutocomplete]="autoContact"
                [matChipInputFor]="chipListContact"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addContact($event)"
                (keyup)="onKeyUp($event)"
                [ngClass]="Contactname.length > 0 ? 'hideInput' : 'showInput'"
              />
            </mat-chip-grid>
            <mat-autocomplete #autoContact="matAutocomplete">
              @for (ContactData of Contactlist; track ContactData) {
                <mat-option class="mat-option_1" (click)="selectedContact(ContactData)">
                  {{ ContactData.CONTACTNAME }}
                </mat-option>
              }
            </mat-autocomplete>
            <mat-icon
              matSuffix
              (click)="ContactMatter()"
              [ngClass]="
                appPermissions?.[3]?.Access == 0 ? 'disabled-click large-button' : 'large-button'
              "
            >
              <!-- <img src="assets/icons/web_app/icon_contact_d.ico"> -->
              @if (currentUser?.THEMECOLOUR == 'theme-default') {
                <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-yellow-light') {
                <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-blue-gray-dark') {
                <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-pink-dark') {
                <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
              }
            </mat-icon>

            <!-- <input matInput [(ngModel)]="EstateLiabilityForm.CONTACTNAME" name="CONTACTNAME" #CONTACTNAME="ngModel"> -->
            <input
              hidden
              matInput
              [(ngModel)]="EstateLiabilityForm.CONTACTGUID"
              name="CONTACTGUID"
              #CONTACTGUID="ngModel"
            />
            <!-- <mat-icon matSuffix (click)='ContactMatter()'>
            <img class="seticon" src="assets/icons/web_app/icon_contact_d.ico" matTooltip="Select Contact" matTooltipPosition="above">
          </mat-icon> -->
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.CONTACTNAME?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.CONTACTNAME?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          @if (action === 'new') {
            <button
              type="button"
              mat-fab
              color="primary"
              class="add-contect-btn"
              (click)="selectNewContect()"
            >
              <mat-icon class="add-icon">add</mat-icon>
            </button>
          }

          <!-- <mat-form-field class="example" appearance="outline" fxFlex="50" class="pr-1">
        <mat-label> Date Incurred</mat-label>
        <input matInput [(ngModel)]="EstateLiabilityForm.DATEINCURRED" name="DATEINCURRED" #DATEINCURRED="ngModel">
        <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.SUBJECT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.SUBJECT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>

      </mat-form-field> -->
          <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
            <mat-label>Date Incurred</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [(ngModel)]="EstateLiabilityForm.DATEINCURRED"
              matTooltip="{{ toolTipList ? toolTipList?.DATEINCURRED?.HOVER : '' }}"
              name="DATEINCURRED"
              #DATEINCURRED="ngModel"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.DATEINCURRED?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.DATEINCURRED?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field class="example" appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Description</mat-label>
      <textarea matInput [(ngModel)]="EstateLiabilityForm.LIABILITYDESCRIPTION" name="LIABILITYDESCRIPTION" matTooltip="{{(toolTipList)?toolTipList?.LIABILITYDESCRIPTION?.HOVER:''}}" #LIABILITYDESCRIPTION="ngModel"></textarea>
      <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.LIABILITYDESCRIPTION?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.LIABILITYDESCRIPTION?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>

    </mat-form-field> -->

          <mat-form-field appearance="outline" fxFlex="100" class="full-width pr-1">
            <mat-label>Description</mat-label>

            <textarea
              matInput
              [(ngModel)]="EstateLiabilityForm.LIABILITYDESCRIPTION"
              name="LIABILITYDESCRIPTION"
              #LIABILITYDESCRIPTION="ngModel"
              rows="4"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="10"
              (keydown.enter)="$event.stopImmediatePropagation()"
              [matTooltip]="
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.LIABILITYDESCRIPTION?.HOVER)
                  : ''
              "
            ></textarea>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.LIABILITYDESCRIPTION?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.LIABILITYDESCRIPTION?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field class="example" appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Amount</mat-label>
            <input
              matInput
              style="text-align: right"
              type="float"
              (focusout)="modelChanged($event, 'AMOUNT')"
              [(ngModel)]="EstateLiabilityForm.AMOUNT"
              name="AMOUNT"
              matTooltip="{{ toolTipList ? toolTipList?.AMOUNT?.HOVER : '' }}"
              #AMOUNT="ngModel"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.AMOUNT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.AMOUNT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-checkbox [(ngModel)]="EstateLiabilityForm.SECURED" name="SECURED" #SECURED="ngModel">
            Secured?
          </mat-checkbox>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button (click)="OnSubmit()" matButton="filled" [disabled]="isspiner">
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      {{ action === 'edit' ? 'Update' : 'Save' }}
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
